import { useTranslation } from 'react-i18next'
import FooterBottom from './FooterBottom'
import { FooterContactColumn } from './FooterContact'
import FooterLogo from './FooterLogo'
import FooterNav from './FooterNav'
import { useFooterData } from './useFooterData'
import './footerShared.css'
import './FooterColumnsLight.css'

function FooterColumnsLayout({ config, variant }) {
  const { t } = useTranslation()
  const { brand, contact, nav, social, year, poweredBy, description } = useFooterData(config)
  const themeClass = variant === 'dark' ? 'footer--columns-dark' : 'footer--columns-light'

  return (
    <footer id="contacto" className={`footer ${themeClass}`}>
      <div className="footer__container">
        <div className="footer__grid">
          <div className="footer__col footer__col--brand">
            <FooterLogo brand={brand} variant={variant} />
            {description ? <p className="footer__description">{description}</p> : null}
          </div>
          <div className="footer__col">
            <h4 className="footer__title">{t('footer.contactUs')}</h4>
            <FooterContactColumn contact={contact} variant={variant} />
          </div>
          <div className="footer__col">
            <h4 className="footer__title">{t('footer.menu')}</h4>
            <FooterNav items={nav} layout="column" variant={variant} />
          </div>
        </div>
        <FooterBottom
          brandName={brand.name || 'Workit'}
          year={year}
          poweredBy={poweredBy}
          social={social}
          variant={variant}
          showSocial
        />
      </div>
    </footer>
  )
}

export default FooterColumnsLayout
